<template>
  <div id="text-field-component">
    <div class="form-group">
      <label v-if="label !== ''" :for="name">
        {{ label }}
        <span v-if="mandatory" class="text-danger"> * </span>
        <a
          v-if="tooltipMessage"
          v-b-tooltip.hover.top="tooltipMessage"
          href="javascript:void(0)"
        >
          <font-awesome-icon
            class="mx-1"
            :icon="`fa-solid fa-exclamation-circle`"
          />
        </a>
      </label>
      <input
        :id="`${name}-${index || ''}`"
        type="text"
        class="form-control"
        :class="`form-control-${size} ${
          fieldState === false ? 'is-invalid' : ''
        }`"
        :decimals="decimals"
        autocomplete="off"
        :value="modelValue"
        :placeholder="placeholder"
        :name="name"
        :readonly="isDisable"
        @blur="$emit('blurEvent', name, index)"
        @input="updateValue"
      />
      <small class="text-muted"> {{ additionalMessage }} </small>
      <error-message-new
        v-if="!fieldState"
        :index="index"
        :errors="errors"
        :fieldName="name"
        :parent="parent"
        :ui-error-message="uiErrorMessage"
      />
    </div>
  </div>
</template>

<script>
import { $hasField } from "@/helper/globalFunction.js";
import { handleFieldState } from "@/helper/fieldStateHandler";

export default {
  props: {
    mandatory: {
      type: Boolean,
      default: false,
    },
    logic: {
      type: Object,
      default: () => ({}),
    },
    content: {
      type: Object,
      default: () => ({}),
    },
    modelValue: {
      type: [String, Number],
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    tooltipMessage: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: "text",
    },
    name: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      default: null,
    },
    decimals: {
      type: Number,
      required: false
    },
    placeholder: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: "sm",
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: String,
      default: null,
    },
    decimals: {
      type: Number,
      required: false
    },
    additionalMessage: {
      type: String,
      default: "",
    },
    uiErrorMessage: {
      type: String,
      default: "",
    },
    showError: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    fieldState() {
      return (
        this.$hasField({
          name: this.name,
          errors: this.errors,
          index: this.index,
          parent: this.parent,
        }) && this.showError
      );
    },
  },
  watch: {
    value: {
      handler(val) {
        if ((this.type == 'double') && (typeof this.decimals !== 'undefined') && (this.decimals > 0)) {
          if (val) this.localValue = val.toFixed(this.decimals);
        } else {
          this.localValue = val;
        }
      },
      immediate: true
    }
  },
  methods: {
    $hasField,
    handleFieldState,
    updateValue($event) {
      this.$emit("update:modelValue", $event.target.value);
    },
  },
};
</script>
